var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.fields.namedRoute}},[_c('div',{staticClass:"card-emendas bg form-group",style:({
      backgroundImage:
        'url(' + require(("@/assets/css/img/" + (_vm.fields.icon))) + ')'
    })},[_c('div',{staticClass:"context"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.fields.nome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarMoeda(_vm.fields.valor)))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b72e30f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardEmendas/index.vue
// module id = mVoC
// module chunks = 15